import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import * as Columns from 'support/columns'
import * as Displays from 'support/displays'
import ButtonWrap from 'ui/layouts/ButtonWrap'
import SquareButton from 'ui/buttons/SquareButton'
import * as Icons from 'ui/icons'
import { Can, CanUseModel, useAuth } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import * as UI from 'ui'
import { WhenModelValue } from '@morningtrain/react-resources'

export default function HistoricShiftRow () {
  const auth = useAuth()

  return (
    <>
      <Columns.Column sortSlug='orderByUserName' label={<span><Translation name='columns.user' /></span>}>
        <b><Displays.Text name='user.name' /></b>
        <br />
        <Displays.Enum name='location' enum='employment_type_category_without_all' />
        {' - '}
        <Displays.Text name='department.name' />
      </Columns.Column>
      <WhenModelValue name='status' condition='pending'>
        <Columns.Column
          label={<span><Translation name='columns.shift_at' /></span>}
          name='pending_started_at'
          sortSlug='orderByDate'
        >
          <UI.Text color='red'>
            <UI.WithSubtitle color={null} subtitle={<span><Displays.Date name='pending_started_at' /></span>}>
              <span><Displays.Time name='pending_started_at' forceUTC /> - <Displays.Time
                name='pending_stopped_at'
                forceUTC
                                                                           />
              </span>
            </UI.WithSubtitle>
          </UI.Text>
        </Columns.Column>
      </WhenModelValue>
      <WhenModelValue name='status' condition='pending' negate>
        <Columns.Column
          label={<span><Translation name='columns.shift_at' /></span>}
          name='started_at'
          sortSlug='orderByDate'
        >
          <UI.WithSubtitle subtitle={<span><Displays.Date name='started_at' /></span>}>
            <span><Displays.Time name='started_at' forceUTC /> - <Displays.Time name='stopped_at' forceUTC /></span>
          </UI.WithSubtitle>
        </Columns.Column>
      </WhenModelValue>
      <Columns.Enum
        name='type'
        enum='toggle_type'
        label={<span><Translation name='columns.type' /></span>}
      />
      <Columns.Column
        label={<span><Translation name='columns.status' /></span>}
        name='started_at'
      >
        <WhenModelValue name='status' condition='pending'>
          <UI.Text color='red'>
            <Displays.Enum name='status' enum='work_time_status' />
          </UI.Text>
        </WhenModelValue>
        <WhenModelValue name='status' condition='pending' negate>
          <Displays.Enum name='status' enum='work_time_status' />
        </WhenModelValue>
      </Columns.Column>
      <Columns.Column
        name='breaks_duration'
        label={<span><Translation name='columns.breaks_duration' /></span>}
        display={<Displays.PreciseDuration name='breaks_duration' unit='minutes' />}
      />
      <Columns.Column
        name='duration_as_minutes'
        sortSlug='duration'
        label={<span><Translation name='columns.duration' /></span>}
        display={<Displays.PreciseDuration name='duration_as_minutes' unit='minutes' />}
      />
      <Columns.Boolean name='has_note' label={<span><Translation name='columns.has_note'/></span>}/>
      <Columns.Column label={<span><Translation name='columns.approved_by'/></span>}>
        <WhenModelValue name='approved_at'>
          <b><Displays.Text name='approver_name'/></b>
          <br/>
          <span><Translation name='columns.approval_time'/></span>: <Displays.Text name='approval_time'/>
        </WhenModelValue>
        <WhenModelValue name='approved_at' negate>
          <span>-</span>
        </WhenModelValue>
      </Columns.Column>
      <Can permission={Permissions.SHIFTS_MANAGE_ENTRIES}>
        <CanUseModel permission='api.shifts.historic.store'>
          <Columns.Column alignment='right'>
            <ButtonWrap className='my-0'>
              <SquareButton color='btn-outlineLight'>
                <Icons.Pencil className='w-4 h-4' />
              </SquareButton>
            </ButtonWrap>
          </Columns.Column>
        </CanUseModel>
      </Can>
    </>
  )
}
